import { create } from 'zustand';
import {
    GetNodoParams,
    getNodos
} from '@/shared/actions/erp/mantenimiento-operaciones/nodo.actions'
import {
    Nodo
} from '@/shared/interfaces/erp/mantenimiento-operaciones/nodo.interface'

interface NodoStore{
 nodo:Nodo[]
 isLoadingNodo:boolean
 getNodos:(params?:GetNodoParams)=>Promise<void>
}

export const useNodoStore = create<NodoStore>(set => ({
    nodo: [],
    isLoadingNodo: false,
    getNodos: async params => {
        set({isLoadingNodo: true})
        const resp=await getNodos(params)
        set({nodo:resp.data.data,isLoadingNodo:false})
    }
}))